/*
 *
 * ImportDivisionsContainer reducer
 *
 */

import { fromJS } from "immutable"
import {
  SAVE_TEMPLATE_PROGRESS,
  SAVE_TEMPLATE_WATCHER,
  SAVE_TEMPLATE_SUCCESS,
  CLOSE_IMPORT,
  UPLOAD_TEMPLATE_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isProcessingDivisions: false,
  percentage: 0,
})

function importDivisionsContainerReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_TEMPLATE_WATCHER:
      return state
        .set("isImporting", false)
        .set("percentage", 0)
        .set("isProcessingDivisions", true)
    case SAVE_TEMPLATE_PROGRESS:
      return state.set("percentage", action.payload.data[0].percentage)
    case SAVE_TEMPLATE_SUCCESS:
      return state.set("percentage", 100)
    case CLOSE_IMPORT:
      return state.set("isProcessingDivisions", false)

    case UPLOAD_TEMPLATE_SUCCESS:
      return state.set("importedSummary", action.payload)
    default:
      return state
  }
}

export default importDivisionsContainerReducer
